import { useEffect } from 'react';
import { parseGaClientIdCookie } from '@cx-web/utils';
import { useIntersectionObserver } from 'usehooks-ts';

export function useTrackCTAImpression(eventData: Record<string, unknown>) {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
  });

  useEffect(() => {
    if (isIntersecting && typeof ENV !== 'undefined' && ENV.ENVIRONMENT !== 'TEST') {
      const { hostname, pathname } = window.location;
      const searchParams = new URLSearchParams({
        ...eventData,
        gaClientId: parseGaClientIdCookie(new Headers({ cookie: document.cookie })),
        pageUrl: pathname,
      });

      fetch(`https://tracking.${getTrackingOrigin(hostname)}/uk-cta-impressions-pixel.png?${searchParams.toString()}`, {
        mode: 'no-cors',
      });
    }
  }, [eventData, isIntersecting]);

  return ref;
}

function getTrackingOrigin(hostname: Location['hostname']) {
  switch (true) {
    case hostname.includes('oddschecker.com'):
    case hostname.includes('whoscored.com'):
    case hostname.includes('https://aipredictor.gazzetta.it/'):
      return 'oddschecker.com';
    default:
      return 'stg.occloud.io';
  }
}
